// src/index.ts
import { registerParser, registerTransform } from "./factory";
import csv from "./parser/csv";
import geojson from "./parser/geojson";
import geojsonVTTile from "./parser/geojsonvt";
import image from "./parser/image";
import json from "./parser/json";
import jsonTile from "./parser/jsonTile";
import mapboxVectorTile from "./parser/mvt";
import raster from "./parser/raster";
import rasterTile, { rasterDataTypes } from "./parser/raster-tile";
import ndi from "./parser/raster/ndi";
import rgb from "./parser/raster/rgb";
import rasterRgb from "./parser/rasterRgb";
import testTile from "./parser/testTile";
import Source from "./source";
import { cluster } from "./transform/cluster";
import { filter } from "./transform/filter";
import { aggregatorToGrid } from "./transform/grid";
import { pointToHexbin } from "./transform/hexagon";
import { join } from "./transform/join";
import { map } from "./transform/map";
import { getParser, getTransform, registerParser as registerParser2, registerTransform as registerTransform2 } from "./factory";
export * from "./interface";
export * from "./source/index";
registerParser("rasterTile", rasterTile);
registerParser("mvt", mapboxVectorTile);
registerParser("geojsonvt", geojsonVTTile);
registerParser("testTile", testTile);
registerParser("geojson", geojson);
registerParser("jsonTile", jsonTile);
registerParser("image", image);
registerParser("csv", csv);
registerParser("json", json);
registerParser("raster", raster);
registerParser("rasterRgb", rasterRgb);
registerParser("rgb", rgb);
registerParser("ndi", ndi);
registerTransform("cluster", cluster);
registerTransform("filter", filter);
registerTransform("join", join);
registerTransform("map", map);
registerTransform("grid", aggregatorToGrid);
registerTransform("hexagon", pointToHexbin);
var src_default = Source;
export {
  src_default as default,
  getParser,
  getTransform,
  rasterDataTypes,
  registerParser2 as registerParser,
  registerTransform2 as registerTransform
};
